import { Port } from "@redux/slices/kontrolEdge/orderSlice";
import axios, { AxiosInstance, AxiosResponse } from "axios";
import { LatencyDetail } from "../InternetDetails/InternetDetails";

const API_URL = process.env.REACT_APP_API_URL;

//Function to get internet list data
export function fetchConnectionList(
  api: AxiosInstance,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/internet?tenantId=${tenantId}&includeChildServices=true`, {
});
}
// &generateDummyData=true

//Function to get the connection detail
export function fetchInternetConnectionAPI(
    api: AxiosInstance,
    connectionId: string,
    tenantId: number, 
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/internet/${connectionId}?tenantId=${tenantId}`);
}

//Function to get the port errors
export function fetchConnectionErrorsAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/internet/${connectionId}/crc-errors?tenantId=${tenantId}`, {
});
}

export function fetchConnectionPerformanceAPI(
  api: AxiosInstance,
  connectionId: string,
  timeRange: string | undefined,
  interval: string,
  tenantId: number,
  destination?: string,
  startDate?: string,  // ISO string
  endDate?: string,    // ISO string
  maxPoints?: number
): Promise<AxiosResponse> {
  const params: Record<string, unknown> = {
    interval,
    includeLatency: true,
  };
  
  // Use custom date range if provided, otherwise use timeRange preset
  if (startDate && endDate) {
    params.start = startDate;
    params.end = endDate;
    if (maxPoints) params.maxPoints = maxPoints;
  } else if (timeRange) {
    params.timeRange = timeRange;
  }
  
  if (destination) params.destination = destination;

  return api.get(
    `/kontroledge/internet/${connectionId}/performance`,
    { params: { tenantId, ...params } }
  );
}



//

//Function to get the connection detail
export function fetchInternetConnectionSubnetsAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/internet/${connectionId}/subnets?tenantId=${tenantId}`);
}

//Function to get the connection BGP
export function fetchConnectionBgpAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/internet/${connectionId}/bgp?tenantId=${tenantId}`);
}

//Function to get the connection subscription Info
export function fetchConnectionSubscriptionAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/internet/${connectionId}/subscription?tenantId=${tenantId}`);
}

export function fetchConnectionLatencyAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
  destination?: string
): Promise<AxiosResponse<{ success: boolean; message: string; data: LatencyDetail }>> {
  return api.get(`/kontroledge/internet/${connectionId}/latency`, {
    params: { tenantId, ...(destination ? { destination } : {}) },
  });
}

// Function to fetch locations
export const fetchLocationsApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/locations`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Function to fetch pricing
export const fetchPricingApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/pricing-plans`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Function to fetch pricing cross-connect
export const fetchPricingCrossConnectApi = (token: string, provider: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/pricing-crossconnect?providerId=1`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { zip: provider }
  });
};


//Fetch of the last mile availability
export const fetchLastMileApi = (token: string, zipCode: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/lastmille/coverage?zip=03333`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { zip: zipCode }
  });
};

//Function to create a port order
export const createPort = (token: string, portData: Port) => {
  return axios.post(
    `${API_URL}/v1/port`,
    portData,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};


//Function to get port list data
export const fetchPortAndLagsApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/order/ports-and-lags-availables/?tenantId=80`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

//Function to get step mbps
export const fetchConnectionCapacityApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/order/step-mbps`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export const fetchMasksApi = (token: string) => {
  return axios.get(`${API_URL}/v1/kontroledge/order/masks?`, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
